import {useQuery} from '@tanstack/react-query';
import * as TestRunsService from '../services/TestRunsService';
import {testingApiAvailable} from '../../testing-api-integration/config';

// Query keys
export const testRunsKeys = {
    all: ['testing-runs'] as const,
    lists: () => [...testRunsKeys.all, 'list'] as const,
    list: (filters: Record<string, string>) => [...testRunsKeys.lists(), {filters}] as const,
    byDefinition: (testDefinitionId: string) => [...testRunsKeys.all, 'by-definition', testDefinitionId] as const,
    details: () => [...testRunsKeys.all, 'detail'] as const,
    detail: (id: string) => [...testRunsKeys.details(), id] as const,
};

// READ-ONLY MODULE (FNP-969). There are deliberately NO mutation hooks in this
// file. openTestRun / closeTestRun / abandonTestRun are @aws_iam — the executor
// canary writes runs, a human never does. Adding a mutation here would fail
// authorization at the API, and more importantly would misrepresent what a run
// IS: a record of something that happened.

export const useTestRunsQuery = (filters: Record<string, string> = {}) => {
    return useQuery({
                        queryKey: testRunsKeys.list(filters),
                        queryFn: () => TestRunsService.fetchRecords(filters),
                        enabled: testingApiAvailable,
                    });
};

export const useTestRunQuery = (id: string) => {
    return useQuery({
                        queryKey: testRunsKeys.detail(id),
                        queryFn: () => TestRunsService.fetch(id),
                        enabled: testingApiAvailable && !!id,
                    });
};

export const useTestRunsByDefinitionQuery = (testDefinitionId: string) => {
    return useQuery({
                        queryKey: testRunsKeys.byDefinition(testDefinitionId),
                        queryFn: () => TestRunsService.fetchRecordsByDefinition(testDefinitionId),
                        enabled: testingApiAvailable && !!testDefinitionId,
                    });
};
